import { IANAZone } from "luxon";

import { DateTime } from "../Types/DateTime";
import { EasyPathInput } from "./EasyPathInput";
import { Service } from "./Service";

export class Appointment {
  id!: string | null;
  centerId!: string;
  customerId!: string;
  createdByUserId?: string;
  services!: Service[];
  startTimeUtc!: string;
  endTimeUtc!: string;
  note!: string | null;
  isClosed?: boolean;
  easyPathInput!: EasyPathInput | null;
}

/** A CRM appointment model extended with additional logic props. */
export class EnhancedAppointment extends Appointment {
  /** The DateTime object for the start time in the correct timezone for the center. */
  startTime: DateTime;
  /** The DateTime object for the end time in the correct timezone for the center. */
  endTime: DateTime;
  /** Flag indicating if the appointment is surgical (at least one surgical service). */
  isSurgical: boolean;

  constructor(appointment: Appointment, centerTimeZone: IANAZone) {
    super();
    this.id = appointment.id;
    this.centerId = appointment.centerId;
    this.customerId = appointment.customerId;
    this.createdByUserId = appointment.createdByUserId;
    this.services = appointment.services;
    this.startTimeUtc = appointment.startTimeUtc;
    this.endTimeUtc = appointment.endTimeUtc;
    this.note = appointment.note;
    this.isClosed = appointment.isClosed;
    this.easyPathInput = appointment.easyPathInput;

    this.startTime = DateTime.fromISO(appointment.startTimeUtc, { zone: centerTimeZone.name });
    this.endTime = DateTime.fromISO(appointment.endTimeUtc, { zone: centerTimeZone.name });
    this.isSurgical = appointment.services.some(p => p.serviceCategory?.isSurgical);
  }
}
